const BANDZ_VEHICLES = {
  Acura: ['CL', 'ILX', 'Integra', 'MDX', 'RDX', 'RL', 'TL', 'TLX', 'TSX'],
  Audi: ['A3', 'A4', 'A5', 'A6', 'A7', 'A8', 'Q3', 'Q5', 'Q7', 'Q8'],
  BMW: ['1 Series', '2 Series', '3 Series', '4 Series', '5 Series', '7 Series', 'X1', 'X3', 'X5', 'X6'],
  Buick: ['Allure', 'Enclave', 'Encore', 'Lacrosse', 'LeSabre', 'Lucerne', 'Regal', 'Rendezvous'],
  Cadillac: ['ATS', 'CTS', 'DeVille', 'DTS', 'Escalade', 'SRX', 'STS', 'XT5', 'XTS'],
  Chevrolet: ['Aveo', 'Camaro', 'Captiva', 'Corvette', 'Cruze', 'Equinox', 'Impala', 'Malibu', 'Silverado', 'Spark', 'Suburban', 'Tahoe', 'Traverse'],
  Chrysler: ['200', '300', 'Aspen', 'Pacifica', 'PT Cruiser', 'Sebring', 'Town & Country'],
  Dodge: ['Avenger', 'Caliber', 'Challenger', 'Charger', 'Dart', 'Durango', 'Journey', 'Magnum', 'Ram'],
  Fiat: ['500', '500L', '500X'],
  Ford: ['Edge', 'Escape', 'Expedition', 'Explorer', 'F-150', 'F-250', 'Focus', 'Fusion', 'Mustang', 'Ranger', 'Taurus'],
  Genesis: ['G70', 'G80', 'G90', 'GV70', 'GV80'],
  GMC: ['Acadia', 'Canyon', 'Envoy', 'Sierra', 'Terrain', 'Yukon'],
  Honda: ['Accord', 'Civic', 'CR-V', 'Fit', 'HR-V', 'Odyssey', 'Passport', 'Pilot', 'Ridgeline'],
  Hyundai: ['Accent', 'Elantra', 'Genesis', 'Kona', 'Palisade', 'Santa Fe', 'Sonata', 'Tucson', 'Veloster'],
  Infiniti: ['EX', 'FX', 'G35', 'G37', 'M', 'Q50', 'Q60', 'QX50', 'QX60', 'QX80'],
  Jaguar: ['F-PACE', 'F-TYPE', 'S-TYPE', 'XE', 'XF', 'XJ', 'XK'],
  Jeep: ['Cherokee', 'Commander', 'Compass', 'Gladiator', 'Grand Cherokee', 'Liberty', 'Patriot', 'Renegade', 'Wrangler'],
  Kia: ['Forte', 'K5', 'Optima', 'Rio', 'Sedona', 'Sorento', 'Soul', 'Sportage', 'Telluride'],
  'Land Rover': ['Discovery', 'Freelander', 'LR2', 'LR3', 'LR4', 'Range Rover'],
  Lexus: ['ES', 'GS', 'GX', 'IS', 'LS', 'LX', 'NX', 'RX', 'SC'],
  Lincoln: ['Aviator', 'Continental', 'Corsair', 'MKC', 'MKS', 'MKT', 'MKX', 'MKZ', 'Navigator'],
  Mazda: ['3', '6', 'CX-3', 'CX-5', 'CX-7', 'CX-9', 'Miata', 'RX-8'],
  Mercedes: ['A-Class', 'C-Class', 'CLA', 'CLS', 'E-Class', 'G-Class', 'GLA', 'GLC', 'GLE', 'S-Class'],
  Mini: ['Clubman', 'Cooper', 'Countryman', 'Paceman'],
  Mitsubishi: ['Eclipse', 'Endeavor', 'Galant', 'Lancer', 'Mirage', 'Outlander'],
  Nissan: ['350Z', '370Z', 'Altima', 'Armada', 'Frontier', 'Maxima', 'Murano', 'Pathfinder', 'Rogue', 'Sentra', 'Titan'],
  Porsche: ['911', 'Boxster', 'Cayenne', 'Cayman', 'Macan', 'Panamera', 'Taycan'],
  Subaru: ['Ascent', 'Crosstrek', 'Forester', 'Impreza', 'Legacy', 'Outback', 'Tribeca', 'WRX'],
  Tesla: ['Model 3', 'Model S', 'Model X', 'Model Y'],
  Toyota: ['4Runner', 'Avalon', 'Camry', 'Corolla', 'Highlander', 'Prius', 'RAV4', 'Sequoia', 'Sienna', 'Tacoma', 'Tundra'],
  Volkswagen: ['Arteon', 'Atlas', 'Beetle', 'Golf', 'Jetta', 'Passat', 'Tiguan', 'Touareg'],
  Volvo: ['C30', 'S40', 'S60', 'S80', 'V50', 'V60', 'XC40', 'XC60', 'XC70', 'XC90']
};

function createOption(value, label = value) {
  const option = document.createElement('option');
  option.value = value;
  option.textContent = label;
  return option;
}

function fillModels(select, make) {
  select.replaceChildren(createOption('', make ? 'Select model' : 'Select make first'));
  select.disabled = !make;
  if (!make) return;
  (BANDZ_VEHICLES[make] || []).forEach((model) => select.append(createOption(model)));
}

function searchUrl(make, model = '') {
  const query = [make, model].filter(Boolean).join(' ');
  return `/search?type=product&q=${encodeURIComponent(query)}`;
}

document.addEventListener('DOMContentLoaded', () => {
  const siteHeader = document.querySelector('.site-header');
  const menuToggle = document.querySelector('.menu-toggle');
  if (siteHeader && menuToggle) {
    const setMenuOpen = (open) => {
      siteHeader.classList.toggle('is-menu-open', open);
      menuToggle.setAttribute('aria-expanded', String(open));
    };

    menuToggle.addEventListener('click', () => {
      setMenuOpen(menuToggle.getAttribute('aria-expanded') !== 'true');
    });
    siteHeader.querySelector('nav')?.addEventListener('click', (event) => {
      if (event.target.closest('a')) setMenuOpen(false);
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') setMenuOpen(false);
    });
  }

  document.querySelectorAll('[data-vehicle-search]').forEach((form) => {
    const year = form.querySelector('[data-fitment-year]');
    const make = form.querySelector('[data-fitment-make]');
    const model = form.querySelector('[data-fitment-model]');
    const query = form.querySelector('[data-vehicle-query]');
    for (let value = new Date().getFullYear() + 1; value >= 1990; value -= 1) year.append(createOption(String(value)));
    Object.keys(BANDZ_VEHICLES).forEach((name) => make.append(createOption(name)));
    make.addEventListener('change', () => fillModels(model, make.value));
    form.addEventListener('submit', (event) => {
      query.value = [year.value, make.value, model.value].filter(Boolean).join(' ');
      if (!query.value) event.preventDefault();
    });
  });

  document.querySelectorAll('[data-vehicle-browser]').forEach((browser) => {
    const makeGrid = browser.querySelector('[data-make-grid]');
    const modelList = browser.querySelector('[data-model-list]');
    const modelTitle = browser.querySelector('[data-model-title]');

    function showMake(make) {
      makeGrid.querySelectorAll('button').forEach((button) => {
        const active = button.dataset.make === make;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
      });
      modelTitle.textContent = `Select your ${make} model`;
      modelList.replaceChildren();
      (BANDZ_VEHICLES[make] || []).forEach((model) => {
        const link = document.createElement('a');
        link.href = searchUrl(make, model);
        link.textContent = model;
        modelList.append(link);
      });
    }

    Object.keys(BANDZ_VEHICLES).forEach((make) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.dataset.make = make;
      button.textContent = make;
      button.setAttribute('aria-pressed', 'false');
      button.addEventListener('click', () => showMake(make));
      makeGrid.append(button);
    });
    showMake('Chevrolet');
  });
});
